export default __webpack_public_path__ + "static/grad_problem-3b2292dc62f509edb2ef8cce1391244a.mp4";